import type { ComponentType } from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import type { IconProps } from '@/components/ui/icons'
import { cn } from '@/lib/utils'

/** Decorative rounded square holding one icon, centred above a card's heading. */
const tileVariants = cva('mx-auto flex items-center justify-center rounded-lg', {
  variants: {
    tone: {
      neutral: 'border border-border bg-surface-page text-body',
      success: 'bg-success-bg text-success',
    },
    size: {
      md: 'h-12 w-12',
      lg: 'h-16 w-16',
    },
  },
  defaultVariants: { tone: 'neutral', size: 'md' },
})

const ICON_SIZE = { md: 'h-5 w-5', lg: 'h-6 w-6' } as const

interface Props extends VariantProps<typeof tileVariants> {
  icon: ComponentType<IconProps>
  className?: string
}

export function IconTile({ icon: Icon, tone, size, className }: Props) {
  return (
    <div aria-hidden="true" className={cn(tileVariants({ tone, size }), className)}>
      <Icon className={ICON_SIZE[size ?? 'md']} />
    </div>
  )
}
